import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/image/logo.svg";

const PublicHeader = () => {
  return (
    <div className="w-full bg-bgColor z-[100] sticky top-0">
      <div className="mx-auto w-full max-w-[1642px] px-0 lg:px-4">
        <div className="mt-[0px] lg:mt-[20px] gap-2 flex items-center justify-between rounded-tl-[0px] lg:rounded-tl-[50px] rounded-tr-[0px] lg:rounded-tr-[50px] rounded-br-[50px] rounded-bl-[50px] border border-[#1e1e1e0D] bg-white px-8 py-4">
          {/* Logo */}
          <div className="flex items-center gap-16">
            <Link to="/" className="flex items-center">
              <img src={logo} alt="ProtectPay" className="w-[195px] h-[42px]" />
            </Link>

            <div className="bg-[#DCEDFF] hidden md:block rounded-[25px] px-[16px] py-[9px]">
              <div className="flex items-center gap-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="21"
                  viewBox="0 0 20 21"
                  fill="none"
                >
                  <path
                    d="M1.00012 9.29821C1.00012 8.72385 1.00012 8.43667 1.07415 8.17221C1.13972 7.93794 1.24749 7.7176 1.39215 7.52201C1.55546 7.30121 1.78214 7.1249 2.23551 6.77228L9.01782 1.49715C9.36914 1.2239 9.54481 1.08727 9.73878 1.03476C9.90993 0.988415 10.0903 0.988415 10.2615 1.03476C10.4554 1.08727 10.6311 1.2239 10.9824 1.49715L17.7647 6.77228C18.2181 7.1249 18.4448 7.30121 18.6081 7.52201C18.7528 7.7176 18.8605 7.93794 18.9261 8.17221C19.0001 8.43667 19.0001 8.72385 19.0001 9.29821V16.5331C19.0001 17.6532 19.0001 18.2133 18.7821 18.6411C18.5904 19.0174 18.2844 19.3234 17.9081 19.5152C17.4803 19.7331 16.9202 19.7331 15.8001 19.7331H4.20012C3.08002 19.7331 2.51996 19.7331 2.09214 19.5152C1.71582 19.3234 1.40986 19.0174 1.21811 18.6411C1.00012 18.2133 1.00012 17.6532 1.00012 16.5331V9.29821Z"
                    stroke="#2A8BF7"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <span className="text-[#2A8BF7] text-[14px] font-[600]">
                  Marketplace
                </span>
              </div>
            </div>
          </div>

          {/* Right: Auth actions */}
          <div className="flex items-center gap-3">
            <Link
              to="/login"
              className="px-[12px] py-[9px] bg-blue-gradient rounded-[8px] font-[600] text-[14px] text-white flex items-center gap-2"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="20"
                viewBox="0 0 22 20"
                fill="none"
              >
                <path
                  d="M21 19V17C21 15.1362 19.7252 13.5701 18 13.126M14.5 1.29076C15.9659 1.88415 17 3.32131 17 5C17 6.67869 15.9659 8.11585 14.5 8.70924M16 19C16 17.1362 16 16.2044 15.6955 15.4693C15.2895 14.4892 14.5108 13.7105 13.5307 13.3045C12.7956 13 11.8638 13 10 13H7C5.13623 13 4.20435 13 3.46927 13.3045C2.48915 13.7105 1.71046 14.4892 1.30448 15.4693C1 16.2044 1 17.1362 1 19M12.5 5C12.5 7.20914 10.7091 9 8.5 9C6.29086 9 4.5 7.20914 4.5 5C4.5 2.79086 6.29086 1 8.5 1C10.7091 1 12.5 2.79086 12.5 5Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span>Login</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PublicHeader;
